
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningRainShowersNightColour as ObiLightningRainShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-rain-showers-night-colour.js';
 
 
 

 
 export const ObiLightningRainShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-rain-showers-night-colour',
   elementClass: ObiLightningRainShowersNightColourElement,
   events: {
     
   }
  });
 
 